require("./c3.css");
module.exports = require("./c3.js");


//////////////////
// WEBPACK FOOTER
// c3 (bower component)
// module id = 1120
// module chunks = 1